<p-dialog *transloco="let t" header="{{ t('termsAndConditions') }}" [(visible)]="isDisplayed" [style]="{width: '50vw'}" (onHide)="closeModal()">
  <div class="p-4">
    <h3>{{t('tnc_regis_header')}}</h3>
    <p>{{t('tnc_regis_1')}}
    </p>
    <p>
     {{t('tnc_regis_2')}}
    </p>
    <p>{{t('tnc_regis_3')}}</p>
    <p>
    {{t('tnc_regis_4')}}
    </p>
    <p>
    {{t('tnc_regis_5')}}
    </p>
    <p>
     {{t('tnc_regis_6')}}
    </p>
    <p>
      {{t('tnc_regis_7')}}
    </p>
    <p>
      {{t('tnc_regis_8')}}
    </p>
    <p>
     {{t('tnc_regis_9')}}
    </p>
    <p>
      {{t('tnc_regis_10')}}
    </p>
    <p>
      {{t('tnc_regis_11')}}
    </p>
    <p>
      {{t('tnc_regis_12')}}
    </p>
    <p>
     {{t('tnc_regis_13')}}
    </p>
    <p>
      {{t('tnc_regis_14')}}
    </p>
    <p>
      {{t('tnc_regis_15')}}
    </p>
    <p>
      {{t('tnc_regis_16')}}
    </p>
    <p>
     {{t('tnc_regis_17')}}
    <br>
      {{t('tnc_regis_17_1')}}
      <br>
      {{t('tnc_regis_17_2')}}
      <br>
      {{t('tnc_regis_17_3')}}
    </p>
    <p>
     {{t('tnc_regis_18')}}
    </p>
    <br>
    <br>
    <h3>{{t('overseas')}}</h3>
    <p>
      {{t('tnc_regis_overseas')}}
      <br>
      1) {{t('tnc_regis_ovr_1')}}
      <br>
      2) {{t('tnc_regis_ovr_2')}}
      <br>
      3) {{t('tnc_regis_ovr_3')}}
      <br>
      4) {{t('tnc_regis_ovr_4')}}
      <br>
      5) {{t('tnc_regis_ovr_5')}}
      <br>
      6)
      <br>
      {{t('tnc_japan')}}
    </p>
    <table style="border-collapse:collapse;border-spacing:0;width: 100%;" class="tg"><thead><tr><td style="border-color:black;border-style:solid;border-width:1px;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:center;vertical-align:middle;word-break:normal" rowspan="4"><span style="font-weight:bold;color:#5196D1">{{t('reserve_cancel')}}</span></td><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_7')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('nofee')}}</td></tr><tr><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_rules')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">30%</td></tr><tr><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_rules_2')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">50%</td></tr><tr><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_date')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#3789d1;font-family:Arial, sans-serif;font-size:14px;font-weight:bold;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">100%</td></tr></thead></table>
    <br>
    <span>
      {{t('other_japan')}}
    </span>
    <table style="border-collapse:collapse;border-spacing:0;width: 100%;" class="tg"><thead><tr><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:center;vertical-align:middle;word-break:normal" rowspan="3">{{t('reserve_cancel')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_rules_other')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('nofee')}}</td></tr><tr><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_rules_other_2')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">50%</td></tr><tr><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">{{t('reserve_rules_other_3')}}</td><td style="border-color:black;border-style:solid;border-width:1px;color:#000000;font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;text-align:left;vertical-align:top;word-break:normal">100%</td></tr></thead></table>
  </div>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="closeModal()" label="Ok" styleClass="p-button-text">
      </p-button>
    </ng-template>
  </p-dialog>